<template>
  <el-dialog
    :visible="visible"
    :width="isMobile ? '300px' : '375px'"
    append-to-body
    :close-on-click-modal="true"
    class="phone-modal"
    @close="beforeClose"
  >
    <loader-wrapper :loading="loading">
      <p style="color: #409eff">
        <b>Изменить телефон контрагента :</b>
      </p>
      <el-form class="demo-ruleForm">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item
              style="margin-bottom: 4px"
              label="Контактный номер из заявки"
              prop="phone"
            >
              <el-input
                v-model="phone"
                v-mask="'+7 (###) ###-##-##'"
                type="text"
                :disabled="true"
                placeholder="телефон"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Телефон контрагента" prop="phoneContragent">
              <p style="font-size: 14px">
                {{ phoneContragent }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-button
            style="width: 100%"
            type="primary"
            :loading="loading"
            @click="actionContargent()"
          >
            Изменить на номер из заявки
          </el-button>
        </el-col>
      </el-row>
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapMutations } from 'vuex'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const Contragents = RepositoryFactory.get('contragents')

export default {
  name: 'PhoneModalInProgress',
  components: { LoaderWrapper },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    response: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      phone: '',
      phoneContragent: '',
    }
  },

  watch: {
    response: {
      handler(val) {
        this.phone = val?.request_phone
        this.phoneContragent = val?.contragent_phone
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations({
      updateResponsesInProgress: 'loadDay/updateResponsesInProgressByPhone',
    }),
    beforeClose() {
      this.phone = ''
      this.loading = false
      this.$emit('close')
    },
    actionContargent() {
      this.loading = true
      Contragents.putContragents({
        id: this.response.contragent_id,
        phone: this.response.request_phone,
      })
        .then(response => {
          if (response.status === 201 || response.status === 200) {
            this.updateResponsesInProgress(response.data)
            this.beforeClose()
            this.$message({
              message: 'Контрагент изменен успешно',
              type: 'success',
            })
            this.$emit('saved')
          }
        })
        .catch(e => this.isErrors(e))
        .finally(() => (this.loading = false))
    },
  },
}
</script>

<style lang="sass">
.phone-modal
  .row-wrap
    margin-bottom: 16px
  .resp-phone-contragent
    font-size: 12px
    font-weight: normal
    color: #98A9BC
    font-weight: normal
    text-transform: lowercase
    display: block

  .action-btn
    min-width: 130px
  .set-date-wrap
    display: flex
    justify-content: flex-start
    align-items: center
    margin-top: 8px
    .el-date-editor
      min-width: 270px
  .el-dialog__body
    color: #000
    *
      font-family: 'Rubik', sans-serif
    .date-at
      color: #67C23A
      font-size: 16px
      font-weight: bold
      margin-top: 8px
      margin-bottom: 4px
    .resp-time
      font-size: 14px
      font-weight: normal
      color: #98A9BC
      margin: 4px 0px
      text-transform: lowercase
    span
      font-size: 16px
      text-transform: uppercase
    p
      font-size: 16px
      text-transform: uppercase
      margin-bottom: 0px
      margin-top: 0px
      &.first
        text-transform: uppercase
        margin: 0px 0px 0px 40px
    .el-timeline-item
    .el-timeline-item__content
      font-size: 14px
      font-weight: bold
      margin-top: 8px
      color: #000
      button
        margin-left: 10px
    .el-timeline-item__node
      border: 1px solid
    .el-timeline-item__timestamp
      margin-left: -30px
      margin-top: 8px!important
      font-size: 14px
      font-weight: normal
      color: #98A9BC
      margin: 0px
    .set-btn
      display: flex
      margin-left: 10px
    .date
      font-size: 15px
      line-height: 14px
      color: #8694A4
      margin: 10px 0
      &.status
        text-decoration: underline
      &.info
        color: #909399
      &.success
        font-size: 16px
        font-weight: bold
        margin-left: 12px
        color: #67C23A
      &.warning
        color: #E6A23C
      &.danger
        color: #F56C6C
</style>
